module.exports = __webpack_public_path__ + "static/media/wifi.4a4645da.svg";